export default {
  cancel: 'キャンセル',
  circle_config: '円の設定',
  confirm: '確認',
  confirm_delete:
    'この機能を削除してもよろしいですか？この操作は元に戻せません。',
  create: '作成',
  delete_geometry: 'ジオメトリを削除',
  delete_vertex: '頂点を削除',
  document_upload_failed: 'ドキュメントのアップロードに失敗しました。',
  draw_circle: '中心からの円',
  draw_circle_2pt: '手動円',
  draw_dialog_begin_drawing: '描画を開始 - 地図上の任意の場所をクリック',
  draw_dialog_cancel_drawing: '描画をキャンセル - ESCキー',
  draw_dialog_remove_vertex: '最後の頂点を削除 - 右クリック',
  draw_dialog_save: '保存 - ダブルクリック',
  draw_dialog_save_single: '保存 - シングルクリック',
  draw_dialog_title: '描画指示',
  draw_line: '線',
  draw_point: '点',
  draw_polygon: '多角形',
  draw_position: '現在の位置',
  draw_rectangle: '長方形',
  edit_dialog_cancel_drawing:
    '描画をキャンセル - 描画をキャンセルするにはキャンセルボタンをクリックします。',
  edit_dialog_modify_shape:
    '形状を編集 - 頂点をドラッグして形状を変更するか、多角形に新しい頂点を追加します。',
  edit_dialog_remove_vertex: '頂点を削除 - 頂点をクリックして削除します。',
  edit_dialog_save: '保存 - 保存ボタンをクリックして変更を保存します。',
  edit_dialog_title: '編集指示',
  filter_searchbox_placeholder: '検索',
  icon_scaling_cluster: 'クラスターアイコンスケール',
  icon_scaling_cluster_log: 'クラスター対数スケール',
  icon_scaling_field: 'フィールドアイコンのスケーリングを切り替え',
  icon_scaling_label: 'アイコンスケール',
  icon_scaling_zoom_in: 'ズームインスケール',
  icon_scaling_zoom_out: 'ズームアウトスケール',
  identical_values_filter:
    'このフィールドには一つの異なる値しか含まれておらず、フィルタリングできません。',
  image_upload_failed: '画像のアップロードに失敗しました。',
  information: '情報',
  invalid_geometry: '無効なジオメトリ',
  invalid_lat_lon: '提供された座標は選択したロケール内にありません。',
  invalid_lat_long_range:
    '無効な座標：緯度と経度の値は有効な範囲内でなければなりません。',
  layer_add_new_location: '新しいロケーションを追加',
  layer_dataview_header: 'データビュー',
  layer_filter_clear_all: 'すべてのフィルターをクリア',
  layer_filter_dropdown_select: '複数選択',
  layer_filter_greater_than: 'より大きい',
  layer_filter_header: 'フィルター',
  layer_filter_less_than: 'より小さい',
  layer_filter_reset_all: 'すべてのフィルターをリセット',
  layer_filter_select: 'リストからフィルターを選択',
  layer_filter_set_filter: 'フィルターを設定',
  layer_grid_legend_ratio: 'サイズに対する色の比率を表示',
  layer_group_hide_layers: 'グループ内のすべてのレイヤーを非表示',
  layer_style_cluster: '複数のロケーション',
  layer_style_display_hover: 'ホバーを有効にする',
  layer_style_display_labels: 'ラベルを表示',
  layer_style_header: 'スタイル',
  layer_style_opacity: 'レイヤーの不透明度を変更:',
  layer_style_select_theme: 'テーマスタイルを選択',
  layer_style_switch_all: 'すべてを切り替える',
  layer_style_switch_caption: 'ラベルをクリックして可視性を切り替えるか、',
  layer_visibility: '可視性を切り替え',
  layer_zoom_to_extent: 'フィルタされたレイヤーの範囲にズーム',
  layers: 'レイヤー',
  link: 'リンク',
  loading: '読み込み中',
  location_clear_all: 'ロケーションをクリア',
  location_close_without_save: '変更を保存せずにロケーションを閉じますか？',
  location_delete: 'ロケーションを削除',
  location_listview_full: 'ロケーションのリストビューは満杯です。',
  location_remove: '選択から機能を削除',
  location_save: 'クラウドに変更を保存',
  location_save_changes: 'このロケーションの変更を保存しますか？',
  location_zoom: '機能の境界に地図をズーム',
  locations: 'ロケーション',
  modify_geometry: 'ジオメトリを変更',
  no_data_filter:
    'このフィールドにはデータが含まれておらず、フィルタリングできません。',
  no_layers: 'ロケール内にアクセス可能なレイヤーはありません。',
  no_locales:
    'あなたのアカウントは確認され、承認されましたが、いかなるロケールにもアクセスできません。これは、管理者が必要な役割を割り当てていないためと思われます。解決するために管理者に連絡してください。',
  no_options_available: '利用可能なオプションはありません。',
  no_results: 'この検索結果はありません',
  ok: 'OK',
  pill_component_remove: '削除',
  pin: 'ピン',
  radius: '半径',
  remove_document_confirm:
    'このドキュメントを削除してもよろしいですか？この操作は元に戻せません。',
  remove_image_confirm:
    '画像を削除してもよろしいですか？この操作は元に戻せません。',
  remove_item_confirm: 'アイテムを削除しますか？',
  remove_last_vertex: '最後の頂点を削除',
  report: 'レポート',
  save: '保存',
  toolbar_admin: 'アカウント管理ビューを開く',
  toolbar_current_location: '現在の位置',
  toolbar_fullscreen: 'フルスクリーンマップビュー',
  toolbar_login: 'ログイン',
  toolbar_logout: 'ログアウト',
  toolbar_zoom_in: 'ズームイン',
  toolbar_zoom_out: 'ズームアウト',
  toolbar_zoom_to_area: 'エリアにズーム',
  units: '単位',
  zoom_to: 'ズームする',
};
